var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2727 6C19.3808 6.00218 19.4833 6.02194 19.5857 6.07063C19.6914 6.12114 19.7843 6.19724 19.8545 6.29091C19.9006 6.35956 19.8898 6.33896 19.8545 6.29091C19.9487 6.41651 20 6.57031 20 6.72727C19.9997 6.68853 19.9981 6.67172 20 6.72727V17.6364C20 18.038 19.6744 18.3636 19.2727 18.3636H4.72727C4.32561 18.3636 4 18.038 4 17.6364V6.72727C4 6.59707 4.03532 6.46779 4.10176 6.35612C4.23716 6.12799 4.47168 6.00515 4.72727 6H19.2727ZM18.5455 8.18182L12.4364 12.7636C12.2036 12.9382 11.8924 12.9556 11.6439 12.816L11.5636 12.7636L5.45455 8.18182V16.9091H18.5455V8.18182ZM6.90909 7.45455L12 11.2727L17.0909 7.45455H6.90909Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.00bcb4ba.svg";
export { ForwardRef as ReactComponent };